module.exports = __webpack_public_path__ + "static/media/victorian.62d88bfd.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/history/victorian.png
// module id = 195
// module chunks = 0